import React from 'react';

const PageContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div className="page-container" style={{ maxWidth: 1200, margin: '0 auto', padding: '20px' }}>
            {children}
        </div>
    );
};

export default PageContainer;
